import React from "react";

const ImageBuffer = ({ data, currentSectionIndex }) => {
  const images = data.map((section, index) => {
    if (index <= currentSectionIndex + 3 && index > currentSectionIndex) {
      if (section.images.sequence) {
        const sequence = section.images.sequenceSources.map((image, index) => {
          return (
            <img
              alt={section.images.imageAltText}
              key={index}
              src={require(`../images/${image}`)}
            />
          );
        });
        return sequence;
      } else {
        return (
          <img
            alt={section.images.imageAltText}
            key={index}
            src={require(`../images/${section.images.name}`)}
          />
        );
      }
    } else {
      return null;
    }
  });

  return (
    <div aria-hidden="true" className="app-buffer">
      {images}
    </div>
  );
};

export default ImageBuffer;
